<template>
  <div class="main-view">
    <el-card class="searchCard" shadow="never">
      <!-- 筛选 -->
      <el-col>
        <el-form :inline="true" class="inline-form">
          <el-form-item label="交易时间">
            <date-range-picker v-model="creatTime" :value="creatTime" ref="creatTime" @getChange="dateChange"></date-range-picker>
          </el-form-item>
          <el-form-item label="交易单号">
            <el-input
              class="search-input"
              v-model="orderId"
              placeholder="交易单号"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="商户交易单号">
            <el-input
              style="width:160px;"
              v-model="merchantOrderId"
              placeholder="商户交易单号"
              auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="商户编号">
            <el-select
              class="search-input"
              v-model="merchantId"
              placeholder="模糊搜索"
              filterable
              :filter-method="handleMerchantInfoFilter">
              <el-option
                v-for="(item, index) in subMerchantNamesList"
                :key="index"
                :label="item.code"
                :value="item.code">
                <span class="value">{{ item.code }}</span>
                <span class="name">{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="交易类型">
            <el-select style="width:120px;" v-model="payType" placeholder="交易类型" @change="payTypeSelectChange">
              <el-option label="扫码" :value="0"></el-option>
              <el-option label="非扫码" :value="1"></el-option>
            </el-select>
            <el-select v-model="payChannel" collapse-tags multiple placeholder="交易渠道">
              <template v-if="payType === 1">
                <el-option label="刷卡" :value="0"></el-option>
              </template>
              <template v-else>
                <el-option label="微信" :value="1"></el-option>
                <el-option label="支付宝" :value="2"></el-option>
                <el-option label="银联二维码" :value="5"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="交易状态">
            <el-select style="width:120px;" v-model="statusType" placeholder="交易状态" @change="statusTypeSelectChange">
              <el-option label="交易 " :value="0"></el-option>
              <el-option label="退款" :value="1"></el-option>
              <el-option label="预授权" :value="2" v-show="payType === 1"></el-option>
            </el-select>
            <el-select v-model="status" collapse-tags multiple placeholder="请先选择交易状态类型">
              <template v-if="statusType === 0">
                <el-option label="交易初始" :value="0"></el-option>
                <el-option label="支付成功" :value="1"></el-option>
                <el-option label="支付失败" :value="2"></el-option>
                <el-option label="订单关闭" :value="6"></el-option>
                <el-option label="冲正成功" :value="7"></el-option>
              </template>
              <template v-if="statusType && statusType === 1">
                <el-option label="退款成功" :value="3"></el-option>
                <el-option label="退款失败" :value="4"></el-option>
                <el-option label="退款中" :value="5"></el-option>
              </template>
              <template v-if="statusType && statusType === 2">
                <el-option label="预授权成功" :value="8"></el-option>
                <el-option label="预授权失败" :value="9"></el-option>
                <el-option label="预授权撤销成功" :value="10"></el-option>
                <el-option label="预授权撤销失败" :value="11"></el-option>
                <el-option label="预授权完成成功" :value="12"></el-option>
                <el-option label="预授权完成失败" :value="13"></el-option>
                <el-option label="预授权完成通知成功" :value="14"></el-option>
                <el-option label="预授权完成通知失败" :value="15"></el-option>
                <el-option label="预授权完成撤销成功" :value="16"></el-option>
                <el-option label="预授权完成撤销失败" :value="17"></el-option>
                <el-option label="预授权冲正成功" :value="18"></el-option>
                <el-option label="预授权冲正失败" :value="19"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="交易金额(元)">
            <el-input
              style="width:100px;"
              v-model="minAmount"
              auto-complete="off"
              placeholder="正整数"></el-input> -
            <el-input
              style="width:100px;"
              v-model="maxAmount"
              auto-complete="off"
              placeholder="正整数"></el-input>
          </el-form-item>
          <el-form-item label="收银员">
            <el-input v-model="searchInfo.username" placeholder="请输入收银员账号"></el-input>
          </el-form-item>
          <el-form-item label="交易来源" v-if="payType !== 1">
            <el-select v-model="sourceType" clearable style="width: 160px">
              <el-option label="收银通PC" :value="24"></el-option>
              <el-option label="收银通APP" :value="25"></el-option>
              <el-option label="POS机" :value="26"></el-option>
              <el-option label="码牌" :value="33"></el-option>
              <el-option label="青蛙条码" :value="39"></el-option>
              <el-option label="青蛙刷脸" :value="40"></el-option>
              <el-option label="蜻蜓条码" :value="41"></el-option>
              <el-option label="蜻蜓刷脸" :value="42"></el-option>
              <el-option label="其他" :value="-1"></el-option>
            </el-select>
            <el-input v-show="![24, 25].includes(sourceType)" style="width:200px;" v-model="sourceValue" :placeholder="sourcePlaceholder"></el-input>
          </el-form-item>
          <el-form-item label="交易来源" v-else>
            <el-select v-model="sourceType" clearable style="width: 160px">
              <el-option label="POS机" :value="1"></el-option>
              <el-option label="其他" :value="-1"></el-option>
            </el-select>
            <el-input style="width:200px;" v-model="sourceValue" :placeholder="sourcePlaceholder" v-if="sourceType !== -1"></el-input>
          </el-form-item>
          <el-form-item>
            <auth-button opt="search" icon="el-icon-search" :plain="true" @click.native="searchClick" label="查询" :loading="loading"></auth-button>
            <auth-button
              icon="el-icon-download"
              opt="export"
              :plain="true"
              :loading="exportButtonLoading"
              @click.native="exportClick"
              label="导出"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!-- table -->
      <el-col>
        <p class="calculate">
          <span class="weightFont">合计</span>&nbsp;&nbsp;&nbsp;
          <span v-if="statusType === 0">
            交易成功金额：
            <span class="weightFont">{{ transAmount || '--' }}</span>&nbsp;&nbsp;&nbsp;
            交易成功金额笔数：
            <span class="weightFont">{{ transCount || '--' }}</span>
          </span>
          <span v-else>
            退款成功金额:
            <span class="weightFont">{{ refundTransAmount || '--' }}</span>
            退款成功笔数：
            <span class="weightFont">{{ refundTransCount || '--' }}</span>
          </span>
        </p>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <el-table
        stripe
        style="width:100%;"
        v-loading="loading"
        :data="merchantTransList"
        :header-cell-style="{background:'#FAFAFA'}">
        <el-table-column
          prop="time"
          label="交易时间"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="orderId"
          label="交易单号"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="merchantOrderId"
          label="商户交易单号"
          align="center"
          min-width="200">
          <template slot-scope="scope">
            <div>{{ scope.row.merchantOrderId || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="merchantId"
          label="商户编号"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="merchantName"
          label="商户简称"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="shopType"
          label="店铺类型"
          align="center"
          min-width="200">
          <template slot-scope="scope">
            <div>{{ scope.row.shopType | formatShopType }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="paymentTypeStr"
          label="交易类型"
          align="center"
          min-width="200">
        </el-table-column>
        <el-table-column
          prop="amount"
          label="交易金额"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <div>{{ Number(scope.row.amount / 100).toFixed(2) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="couponAmount"
          label="优惠金额"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <div>{{ Number(scope.row.couponAmount / 100).toFixed(2) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="buyerPayAmount"
          label="实付金额"
          min-width="150"
          align="center">
          <template slot-scope="scope">
            <div>{{ Number(scope.row.buyerPayAmount / 100).toFixed(2) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="settleAmount"
          label="应结订单金额"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <div>{{ Number(scope.row.settleAmount / 100).toFixed(2) }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="statusStr"
          label="交易状态"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="refunId"
          label="退款订单号"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          prop="fMerchantRefundId"
          label="商户退款订单号"
          align="center"
          min-width="150">
        </el-table-column>
        <el-table-column
          v-if="isWoWoAgent"
          prop="fMerchantSubsidy"
          label="手续费补贴"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.fMerchantSubsidy / 100 || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="isWoWoAgent"
          prop="fUserSubsidy"
          label="营销补贴"
          align="center"
          min-width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.fUserSubsidy / 100 || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="userName"
          label="收银员"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="attach"
          label="备注"
          min-width="300"
          align="center">
          <template slot-scope="scope">
            <span>{{scope.row.attach || '-'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="posNo"
          label="机器SN"
          min-width="300"
          align="center">
          <template slot-scope="scope">
            <span>{{scope.row.posNo || '-'}}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <pagination @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNo"></pagination>
  </div>
</template>

<script>
import qs from 'qs'
import { parseTime } from '@/utils/formatTime'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import { getAllSubMerchantNames, listMerchantTrans, exportMerchantTrans } from '@/api/transaction.js'
export default {
  name: 'TradeDataInfo',
  components: {
    dateRangePicker,
    pagination
  },
  data () {
    const todayStr = parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')
    const toadyZero = new Date(new Date().getTime() - 3600 * 1000 * 24 * 30)
    const todayZeroStr = parseTime(toadyZero, '{y}-{m}-{d} {h}:{i}:{s}')
    return {
      loading: false,
      // 需要给分页组件传的信息
      paginations: {
        pageNo: 1,
        count: 0,
        pageSize: 20
      },
      // 搜索表单信息
      searchInfo: {
        startTime: '',
        endTime: '',
        merchantId: '',
        orderId: '',
        merchantOrderId: '',
        payType: '',
        paymentChannels: '',
        statusType: '',
        status: '',
        minAmount: '',
        maxAmount: '',
        agentType: '',
        username: ''
      },
      creatTime: [todayZeroStr, todayStr],
      merchantId: '',
      orderId: '',
      merchantOrderId: '',
      payType: 0,
      payChannel: [1, 2, 5],
      maxAmount: '',
      minAmount: '',
      statusType: 0,
      status: [0, 1, 2, 6, 7],
      sourceType: '', // 交易来源
      sourceValue: '', // 交易来源细分
      // tableLoading: false,
      exportButtonLoading: false,
      subMerchantNamesList: [],
      subMerchantNamesList_back: [],
      merchantTransList: [],
      transAmount: '',
      transCount: '',
      refundTransAmount: '',
      refundTransCount: '',
      isWoWoAgent: false
    }
  },
  watch: {
    payChannel (val, oldVal) {
      // 如果是窝窝代理商，不能同时选中扫码和云闪付
      if (this.isWoWoAgent) {
        if (oldVal.includes(5) && (val.includes(1) || val.includes(2)) && val.includes(5)) {
          const index = oldVal.indexOf(5)
          this.payChannel.splice(index, 1)
        }
        if ((oldVal.includes(1) || oldVal.includes(2)) && val.includes(5)) {
          this.payChannel = [5]
        }
      }
    }
  },
  mounted () {
    // this.getAllSubMerchantNames()
    const agentId = this.$store.getters.userInfo.userEntity.fAgentId
    if (agentId && ['5387968', '1515509'].includes(agentId)) {
      this.isWoWoAgent = true
      this.searchInfo.agentType = agentId.substr(0, 3)
      this.payChannel = [1, 2]
    } else {
      this.isWoWoAgent = false
    }
    this.getDefaultData()
  },
  beforeDestroy () {},
  methods: {
    /**
     * @description 初始加载数据方法
     */
    async getDefaultData () {
      // this.loading = true
      await this.getAllSubMerchantNames()
      await this.searchClick()
      this.loading = false
    },
    /**
     * @description 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNo = page
      this.searchClick(true)
    },
    validAmount () {
      var num = /^[0-9]+$/
      if (this.minAmount !== '' && (!num.test(this.minAmount))) {
        this.minAmount = ''
        this.$message({
          showClose: true,
          message: '交易金额必须为正整数',
          type: 'warning'
        })
        return false
      }
      if (this.maxAmount !== '' && (!num.test(this.maxAmount))) {
        this.maxAmount = ''
        this.$message({
          showClose: true,
          message: '交易金额必须为正整数',
          type: 'warning'
        })
        return false
      }
      if (this.minAmount !== '' && this.maxAmount !== '') {
        if (parseInt(this.minAmount) > parseInt(this.maxAmount)) {
          this.maxAmount = ''
          this.$message({
            showClose: true,
            message: '最大交易金额不能小于最小金额',
            type: 'warning'
          })
          return false
        }
      }
      return true
    },
    /**
     * 交易类型选择change
     */
    payTypeSelectChange (value) {
      if (value === 0) {
        this.payChannel = [1, 2, 5]
        if (this.statusType === 2) {
          this.statusType = 0
          this.statusTypeSelectChange(0)
        }
      }
      if (value === 1) {
        this.payChannel = [0]
      }
      this.sourceType = ''
    },
    /**
     * 交易状态选择change
     */
    statusTypeSelectChange (value) {
      if (!value && value !== 0) {
        this.status = []
      }
      if (value === 0) {
        this.status = [0, 1, 2, 6, 7]
      }
      if (value === 1) {
        this.status = [3, 4, 5]
      }
      if (value === 2) {
        this.status = [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19]
      }
    },
    /**
     * @description 筛选查询按钮点击
     */
    searchClick (noReset) {
      if (this.payType === 1 && !this.merchantId && !this.orderId) {
        this.$message({
          message: '请先输入交易单号或商户编号',
          type: 'warning'
        })
        return
      }
      if (this.creatTime.length === 0 || !this.creatTime[0] || !this.creatTime[1]) {
        this.$message({
          message: '请筛选时间进行查询',
          type: 'error'
        })
        return
      }
      console.log('查询点击')
      var amountflag = this.validAmount()
      if (!amountflag) {
        return
      }
      this.setSearchInfoParams(noReset)
      this.listMerchantTrans()
    },
    /**
     * 导出按钮点击
     */
    exportClick () {
      console.log('导出点击')
      if (this.payType === 1 && !this.merchantId && !this.orderId) {
        this.$message({
          message: '请先输入交易单号或商户编号',
          type: 'warning'
        })
        return
      }
      var amountflag = this.validAmount()
      if (!amountflag) {
        return
      }
      this.setSearchInfoParams(true)
      // const startDate = new Date(this.searchInfo.startTime)
      // const endDate = new Date(this.searchInfo.endTime)
      // if (!this.searchInfo.startTime || !this.searchInfo.endTime || endDate.getTime() - startDate.getTime() > 3600 * 1000 * 24 * 30) {
      if (!this.searchInfo.startTime || !this.searchInfo.endTime) {
        this.$message({
          // message: '请筛选1个月内的数据进行导出',
          message: '请筛选时间进行导出',
          type: 'error'
        })
        return
      }
      this.exportMerchantTrans()
    },
    /**
     * 组装筛选参数
     */
    setSearchInfoParams (noReset) {
      this.searchInfo.minAmount = this.minAmount || ''
      this.searchInfo.maxAmount = this.maxAmount || ''
      this.searchInfo.startTime = this.creatTime && this.creatTime[0] ? this.creatTime[0] : ''
      this.searchInfo.endTime = this.creatTime && this.creatTime[1] ? this.creatTime[1] : ''
      this.searchInfo.merchantId = this.merchantId.replace(/ /g, '') || ''
      this.searchInfo.orderId = this.orderId.replace(/ /g, '') || ''
      this.searchInfo.merchantOrderId = this.merchantOrderId.replace(/ /g, '') || ''
      this.searchInfo.payType = this.payType
      this.searchInfo.paymentChannels = this.payChannel.join(',')
      this.searchInfo.statusType = this.statusType
      this.searchInfo.status = this.status.join(',')
      this.searchInfo.sourceType = this.sourceType
      this.searchInfo.sourceValue = this.sourceValue
      this.formatParams(this.searchInfo)
      if (noReset !== true) {
        this.paginations.pageNo = 1
        this.paginations.count = 0
      }
      Object.assign(this.searchInfo, this.paginations)
    },
    dateChange (value) {
      this.creatTime = value
    },
    /**
     * @description 删除提交参数中的空字段
     * @param {Object} params 搜索内容对象
     */
    formatParams (params) {
      for (const key in params) {
        // eslint-disable-next-line no-prototype-builtins
        if (params.hasOwnProperty(key) && !params[key] && params[key] !== 0) {
          delete params[key]
        }
      }
    },
    /**
     * 商户选择筛选商户方法
     */
    handleMerchantInfoFilter (queryString) {
      if (queryString) {
        this.subMerchantNamesList = this.subMerchantNamesList_back.filter(item => {
          return item.code.toLowerCase().includes(queryString.toLowerCase()) || item.name.toLowerCase().includes(queryString.toLowerCase())
        })
      } else {
        this.subMerchantNamesList = this.subMerchantNamesList_back
      }
    },
    /**
     * 获取商户编号下拉列表
     */
    getAllSubMerchantNames () {
      return new Promise((resolve, reject) => {
        getAllSubMerchantNames('').then(response => {
          console.log('getAllSubMerchantNames response:', response)
          if (response.error_code === '0') {
            this.subMerchantNamesList = response.data
            this.subMerchantNamesList_back = [...this.subMerchantNamesList]
            this.merchantId = this.subMerchantNamesList[0].code
            resolve()
          } else {
            this.loading = false
            this.$message({
              message: response.error_msg,
              type: 'error'
            })
            resolve(false)
          }
        }).catch(err => {
          reject(err)
          this.loading = false
        })
      })
    },
    /**
     * 交易订单查询
     */
    listMerchantTrans () {
      this.loading = true
      const params = qs.stringify(this.searchInfo)
      listMerchantTrans(params).then(response => {
        this.loading = false
        if (response.error_code === '0') {
          this.merchantTransList = response.data.list
          this.paginations.count = response.data.totalCount
          this.transAmount = response.data.transAmount
          this.refundTransAmount = response.data.refundTransAmount
          this.transCount = response.data.transCount
          this.refundTransCount = response.data.refundTransCount
          if (parseInt(this.paginations.count) > 10000) {
            this.$message({
              message: '最多筛选出10000条数据，请重新筛选',
              type: 'warning'
            })
          }
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    /**
     * 交易订单查询导出
     */
    exportMerchantTrans () {
      this.exportButtonLoading = true
      const params = qs.stringify(Object.assign({}, this.searchInfo, {
        moduleCode: 1,
        moduleName: '交易',
        menuName: '交易流水'
      }))
      exportMerchantTrans(params).then(response => {
        this.exportButtonLoading = false
        if (response.error_code === '0') {
          this.$message({
            message: '导出成功，请大约1min后在下载中心中查看并下载',
            type: 'success'
          })
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    },
    formatDate (item) {
      return parseTime(new Date(item.fTime), '{y}-{m}-{d} {h}:{i}:{s}')
    }
  },
  computed: {
    sourcePlaceholder () {
      let result
      switch (this.sourceType) {
        case 24: {
          result = '请输入收银员账号'
          break
        }
        case 25: {
          result = '请输入收银员账号'
          break
        }
        case 26:
        case 1: {
          result = '请输入POS机的SN号'
          break
        }
        case 33: {
          result = '请输入码牌编号'
          break
        }
        case -1: {
          result = '请输入收银机编号'
          break
        }
        default: {
          result = '请输入'
        }
      }
      return result
    }
  },
  filters: {
    formatShopType (value) {
      switch (value) {
        case 0:
          return '分店'
        case 1:
          return '总店'
        default:
          return '未知'
      }
    }
  }
}
</script>

<style scoped>
.main-view {
  padding-left: 16px;
}
.search-input {
  width: 160px;
}
.btm-action {
  margin: 20px 0;
  text-align: center;
}
.calculate{
    font-size: 14px;
}
.calculate .weightFont{
    font-weight: bold;
}
</style>
